<template>
  <!-- NOTE: This is the student list in the Roundtable Discussion View - Side nav with avatars -->
  <div class="activity-side-bar student-list no-padding">
    <!-- Engagement report top button -->
    <span class="tc b"> Summary Reports </span>
    <div
      class="row middle-xs activity-list mt2"
      :class="{ activitySelected: summarySelected }"
      style="margin-bottom: 20px"
      @click="$emit('summarySelected')"
    >
      <i style="margin-left: 2px" class="fa fa-bar-chart"></i>
      <li class="col-xs-10 start-xs">
        <p class="truncate-text">Trending Reports</p>
      </li>
    </div>

    <!-- List of activities -->
    <div
      v-if="online_rts.length"
      class="tc"
      style="cursor: default; margin-bottom: 10px"
    >
      <span class="b" style="margin-bottom: 40px"> Written RoundTables </span>
      <div class="online_rt_activities mt3">
        <template v-for="(activity, index) in online_rts">
          <div
            class="row middle-xs activity-list"
            :key="index"
            :class="{ activitySelected: isSelected(activity.id) }"
            @click="selectActivity(activity)"
          >
            <li class="col-xs-10 start-xs">
              <p class="truncate-text">{{ activity.title }}</p>
            </li>
          </div>
        </template>
      </div>
    </div>
    <div v-if="live_rts.length" class="tc" style="cursor: default">
      <span class="b"> Verbal RoundTables </span>
      <div class="live_rt_activities mt3">
        <template v-for="(activity, index) in live_rts">
          <div
            class="row middle-xs activity-list"
            :key="index"
            :class="{ activitySelected: isSelected(activity.id) }"
            @click="selectActivity(activity)"
          >
            <li class="col-xs-10 start-xs">
              <p class="truncate-text">{{ activity.title }}</p>
            </li>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="babel">

  export default {
    data() {
      return {
        selected: null,
        online_rts:[],
        live_rts:[],
      };
    },
    watch: {
      activities(){
        if (this.activities && this.activities.length){
          this.getSeparatedActivities();
        }
      }
    },
    computed: {
    },
    props: {
      summarySelected: {
        type: Boolean,
        default: false,
      },
      activities: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    methods: {
      selectActivity(activity) {
        this.selected = activity.id;
        this.$emit('activitySelected', activity);
      },
      getSeparatedActivities(){
        this.online_rts = this.activities.filter(act => act.type === 'roundtable').
        sort((a, b)=> {
          return a.published_date - b.published_date;
        });
        this.live_rts = this.activities.filter(act => act.type === 'live_discussion').
        sort((a, b)=> {
          return a.published_date - b.published_date;
        });
      },
      isSelected(id) {
        return this.selected === id && !this.summarySelected;
      },
    },
    mounted(){

    },
    beforeUpdate() {
      this.selected = this.$route.query.activityID;
    },
  };
</script>

<style scoped lang="stylus">
  .activity-side-bar
    .activitySelected
      background: #d8d8d8 !important
     &&::-webkit-scrollbar
      display: block !important;
      width: 10px !important;
      -webkit-appearance: none;
    .icons
      width: 9%
      height: 9%

    .activity-list
      padding: 5px 0 5px 15px
      border: 0.5px solid transparent

    .activity-list:hover
      background: #d8d8d8
      cursor: pointer
      cursor: hand

    li
      list-style-type: none
      padding: 0px 8px 0px 0px
      max-height: 30px

    li p
      padding: 0px 0px 0px 4px
      margin: 0
      border: 3px solid transparent
      border-radius: 20px
</style>



// WEBPACK FOOTER //
// activitiesSideBar.vue?2dc18ee3